var map = {
	"./ship-cargo.png": 384,
	"./ship-fishing.png": 3384,
	"./ship-high-speed-craft.png": 7308,
	"./ship-navigation.png": 5448,
	"./ship-passenger.png": 7088,
	"./ship-pleasure.png": 1416,
	"./ship-tanker.png": 1610,
	"./ship-tug-special.png": 4800,
	"./ship-unspecified.png": 2524
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9864;